import { render, staticRenderFns } from "./fresh-water-form.vue?vue&type=template&id=773f62a1&scoped=true&"
import script from "./fresh-water-form.vue?vue&type=script&lang=js&"
export * from "./fresh-water-form.vue?vue&type=script&lang=js&"
import style0 from "./fresh-water-form.vue?vue&type=style&index=0&id=773f62a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773f62a1",
  null
  
)

export default component.exports